import { defineStore } from "pinia";
import { computed } from "vue";
import { makeLogger } from "@/shared/consola";
import { t } from "@/i18n";
import {
    BookIcon,
    Building2Icon,
    CalendarIcon,
    CoinsHandIcon,
    PlayerIcon,
    UserMultipleIcon,
} from "@easy/ui/icons";
import { useOnboarding } from "@/shared/projects/onboarding/useOnboarding";
import { useActions, useMutations, useState } from "@/store/vuex-composition-mappers";
import { mapThemeToPageColors } from "@/shared/projects/prepare-theme";
import SvgPageLayout from "@/apps/page/project/onboarding/svg-previews/SvgPageLayout.vue";
import { pageOnboardingService } from "@/apps/page/project/onboarding/page-onboarding.service";

const STORE_NAME = "page-creator";
const logger = makeLogger("🍍" + STORE_NAME);

export const usePageCreatorStore = defineStore(STORE_NAME, () => {
    logger.trace("👋hello");

    const { page } = useState("page", ["page"]);
    const { saveSnapshot } = useActions("page/projects", ["saveSnapshot"]);
    const { showAlert } = useMutations(["showAlert"]);

    const {
        isCreatorShown,
        onboardState,
        previewCssVars,
        autoOpenCreator,
        toggleCreatorShown,
        updateProductInfo,
        validate,
    } = useOnboarding({
        // autoOpenRules: (sections) => sections.filter((t) => !t._deleted).length === 0,
    });

    onboardState.template = "course";
    onboardState.hidePrompt = true;
    /*
        'course',
      'webinar',
      'community',
      'e-book',
      'saas', // & licences
      'event', // & tickets
    * */

    const templates = computed(() => [
        {
            value: t("love.templates.empty"),
            id: "empty",
        },
        /*        {
            value: t("love.templates.product"),
            icon: StoreIcon,
            id: "product",
        },*/
        {
            value: t("love.templates.training"),
            icon: CalendarIcon,
            id: "course",
        },
        {
            value: "E-book",
            icon: BookIcon,
            id: "e-book",
        },
        /*{
            value: t("love.templates.consultations"),
            icon: BusinessHandshakeIcon,
            id: "consultations",
        },*/
        {
            value: t("love.templates.community"),
            icon: UserMultipleIcon,
            id: "community",
        },
        {
            value: "Webinar",
            icon: PlayerIcon,
            id: "webinar",
        },
        {
            value: t("love.templates.service"),
            icon: CoinsHandIcon,
            id: "saas",
        },
        {
            value: t("love.templates.event"),
            icon: Building2Icon,
            id: "event",
        },
    ]);

    const layouts = computed(() => []);

    const previewComponent = computed(() => SvgPageLayout);

    return {
        onboardState,
        isCreatorShown,
        templates,
        layouts,
        previewCssVars,
        previewComponent,
        links: computed(() => ({
            video: "",
            docs: "",
        })),
        autoOpenCreator,
        onboardingAction(resolveResponse) {
            return async () => {
                if (!validate()) {
                    return;
                }
                try {
                    onboardState.isLoading = true;
                    await resolveResponse();
                    // sseSubscriber will resolve the data next...
                } catch (e) {
                    logger.error(e);
                    onboardState.isLoading = false;
                }
            };
        },
        async sseSubscriber({ type, payload }) {
            if (type === pageOnboardingService.EVENTS.GENERATED) {
                const { theme, layout } = onboardState;
                logger.debug("about to fillWithExample", { payload, theme, layout });
                for (const [key, value] of Object.entries(mapThemeToPageColors(theme))) {
                    page.value[key] = value;
                }
                showAlert({
                    type: "success",
                    title: t("shared.creator.generation_success"),
                });
                await saveSnapshot();
                toggleCreatorShown(false);
                onboardState.isLoading = false;
            } else if (type === pageOnboardingService.EVENTS.GENERATION_ERROR) {
                showAlert({
                    type: "error",
                    title: t("shared.creator.generation_error"),
                    message: payload.message,
                });
                onboardState.isLoading = false;
            }
        },
        toggleCreatorShown,
        updateProductInfo,
        validate,
    };
});
